import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


const initialState: { holidayIds: number[], isReset: boolean } = { holidayIds: [], isReset: false }

const HolidaySlice = createSlice({
    name: 'Holiday',
    initialState,
    reducers: {
        SET_HOLIDAY_IDS(state, action: PayloadAction<any>) {
            state.holidayIds = action.payload
            state.isReset = false
        },
        RESET_HOLIDAY_ID(state, action: PayloadAction<any>) {
            state.holidayIds = action.payload
            state.isReset = true
        }
    },
})

export const { SET_HOLIDAY_IDS, RESET_HOLIDAY_ID } = HolidaySlice.actions
export default HolidaySlice.reducer